module.exports = __webpack_public_path__ + "static/img/6832_phase_function_Paper_Points.4e1612d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6832_phase_function_Paper_Points.png
// module id = IS3/
// module chunks = 0